import {Fragment, h} from "preact";
import Input from "../../../Input";
import s from "../beneficiaryForm.module.css";

const ParentalFields = (props) => {
    // Destructured props
    const {
        formValues,
        errors,
        handleChange
    } = props;

    return (
        <Fragment>
            <div className={'w-full grid grid-cols-1 md:grid-cols-2 grid-flow-col gap-[1.5rem]'}>
                <Input
                    type={"text"}
                    label={"Nome do responsável:"}
                    name={"responsibleName"}
                    placeholder={"Digite o nome do responsável"}
                    handleChange={handleChange}
                    value={formValues.responsibleName}
                    error={errors.responsibleName}
                    isRequired={true}
                />
            </div>
        </Fragment>
    )
}

export default ParentalFields;
